import React from 'react';
import { Box, Typography, Grid, styled } from '@mui/material';
import {
  Label,
  Value
} from './styles';
import { PatientInfo } from '../../types/genomic';

export const LogoContainer = styled(Box)(({ theme }) => ({
  width: '120px',
  height: '120px',
  marginLeft: theme.spacing(3),
  marginTop: "-1.5em",
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  }
}));

const InfoGrid = styled(Grid)(({ theme }) => ({
  borderLeft: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(0, 2),
  '& .MuiGrid-item': {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  }
}));


interface Props {
  reportName: string;
  reportDescription: string;
  patient: PatientInfo;
  hasVariants?: boolean;
}

/*const HiddenUnlessPrintablePage = styled(PrintablePage)(() => ({
  display: 'none',
  "@media print": {
    display: 'block',
  },
}));*/

export const ReportTitleSection: React.FC<Props> = ({ 
  reportName, 
  reportDescription, 
  patient
}) => {
  const reportDate = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  return (
    <Box sx={{ 
      position: 'relative',
      borderBottom: '1px solid',
      borderColor: 'divider',
      pb: 3,
      mb: 4,
      mt: 4
    }}>
      <Box sx={{ 
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        mb: 2 
      }}>
        <Box>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '1.75rem', md: '2rem' },
              color: 'primary.main',
              lineHeight: 1.1,
              mb: 0.5
            }}
          >
            {reportName}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
              mb: 1,
              maxWidth: '600px'
            }}
          >
            {reportDescription}
          </Typography>
        </Box>
        <LogoContainer>
          <img src="/logo.svg" alt="Logo" />
        </LogoContainer>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Typography variant="h6" sx={{ 
            fontSize: '1.1rem',
            fontWeight: 500,
            mb: 0.5 
          }}>
            {patient.name}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Report Date: {reportDate}
          </Typography>
        </Grid>
        
        <Grid item xs={8}>
          <InfoGrid container>
            <Grid item xs={6}>
              <Label sx={{ fontSize: '0.75rem' }}>Date of Birth</Label>
              <Value sx={{ fontSize: '0.875rem' }}>{patient.dateOfBirth}</Value>
            </Grid>
            <Grid item xs={6}>
              <Label sx={{ fontSize: '0.75rem' }}>Sex</Label>
              <Value sx={{ fontSize: '0.875rem', textTransform: 'capitalize' }}>{patient.sex}</Value>
            </Grid>
            <Grid item xs={6}>
              <Label sx={{ fontSize: '0.75rem' }}>Sample ID</Label>
              <Value sx={{ fontSize: '0.875rem' }}>{patient.sampleId}</Value>
            </Grid>
            <Grid item xs={6}>
              <Label sx={{ fontSize: '0.75rem' }}>Collection Date</Label>
              <Value sx={{ fontSize: '0.875rem' }}>{patient.collectionDate}</Value>
            </Grid>
          </InfoGrid>
        </Grid>
      </Grid>

    </Box>
  );
}; 